import React from 'react';
import classNames from 'classnames';

import IconProfileCard from '../IconProfileCard/IconProfileCard';

import css from './ToolTip.module.css';

const ToolTip = props => {
  const { className, tipText, headingText = "", subhedingText = "", bulletPoints, subhedingTextArray } = props;
  const classes = classNames(className || css.containerWrapper);

  return (
    <span className={classes}>
     <span className={css.tooltipContainer}>
        <IconProfileCard type="info" />
        <div className={css.tooltip}>
          <div className={css.tooltipFlex}>
            <span className={css.tooltipTtext}>
              <div className={css.headingText}>{headingText}</div>
            </span>
          </div>
        </div>
      </span>
      <label>
        {tipText}
      </label>

    </span>
  );
};

export default ToolTip;
